import { render, staticRenderFns } from "./VocCharts.vue?vue&type=template&id=dba758c8&scoped=true&"
import script from "./VocCharts.vue?vue&type=script&lang=js&"
export * from "./VocCharts.vue?vue&type=script&lang=js&"
import style0 from "./VocCharts.vue?vue&type=style&index=0&id=dba758c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba758c8",
  null
  
)

export default component.exports